import { takeEvery } from "redux-saga/effects";
import * as initActions from "./actionTypes";
import { signInSaga, onboardingGetSaga, onboardingUpdateSaga, signUpSaga, tagsSaga, mentorSaga, scenariosSaga, submitScenarioSaga, getResultsSaga, setResultsSaga, getPricingPlanSaga, setPricingPlanSaga, getProfileSaga, setProfileSaga, getRecommendationsSaga, getFeedBackSaga, getSessionsSaga, getIndustriesSaga, getQuotesSaga, getStudentResourcesSaga, getGreatFindsSaga, getRecommendationsQuesSaga, getaiCompanionsSaga, sendChatMsgAi, getChatHistorySaga, updateChatFeedbackSaga, setResultsDetailSaga, saveInterestedCareer, getStrengthsSaga, getCareersSaga, setCareersSaga, fetchPromptStatusSaga, logPromptSaga } from "./sagas";
import { setProfilePasswordSaga } from "./sagas/setProfileSaga";
import { getAffiliateSaga } from "./sagas/getResultsSaga";
import { addTermsSaga, deleteTermSaga, downloadActionSaga, generateIdeasSaga, getTermsSaga, reorderTermsSaga } from "./sagas/actionPlanSaga";

export function* rootSaga() {
  yield takeEvery(initActions.INIT_SIGNIN, signInSaga);
  yield takeEvery(initActions.INIT_ONBOARDING_GET, onboardingGetSaga);
  yield takeEvery(initActions.INIT_ONBOARDING_UPDATE, onboardingUpdateSaga);
  yield takeEvery(initActions.INIT_SIGNUP, signUpSaga);
  yield takeEvery(initActions.INIT_TAGS, tagsSaga);
  yield takeEvery(initActions.INIT_MENTORS, mentorSaga)
  yield takeEvery(initActions.INIT_SCENARIOS, scenariosSaga)
  yield takeEvery(initActions.INIT_SUBMIT_SCENARIOS, submitScenarioSaga)
  yield takeEvery(initActions.INIT_RESULTS, getResultsSaga)
  yield takeEvery(initActions.INIT_SET_RESULTS, setResultsSaga)
  yield takeEvery(initActions.INIT_GET_PRICING_PLAN, getPricingPlanSaga)
  yield takeEvery(initActions.INIT_SET_PRICING_PLAN, setPricingPlanSaga)
  yield takeEvery(initActions.INIT_GET_PROFILE, getProfileSaga)
  yield takeEvery(initActions.INIT_SET_PROFILE, setProfileSaga)
  yield takeEvery(initActions.INIT_SET_PROFILE_PASSWORD, setProfilePasswordSaga)
  yield takeEvery(initActions.INIT_GET_RECOMMENDATIONS, getRecommendationsSaga)
  yield takeEvery(initActions.INIT_GET_FEEDBACKS, getFeedBackSaga)
  yield takeEvery(initActions.INIT_GET_SESSIONS, getSessionsSaga)
  yield takeEvery(initActions.INIT_INDUSTRY, getIndustriesSaga)
  yield takeEvery(initActions.INIT_GET_QUOTES, getQuotesSaga);
  yield takeEvery(initActions.INIT_GET_STUDENT_RESOURCES, getStudentResourcesSaga);
  yield takeEvery(initActions.INIT_GET_STUDENT_RESOURCES_GREAT_FINDS, getGreatFindsSaga);
  yield takeEvery(initActions.INIT_RECOMMENDATIONS_QUESTION, getRecommendationsQuesSaga);
  yield takeEvery(initActions.INIT_GET_AI_COMPANIONS, getaiCompanionsSaga);
  yield takeEvery(initActions.INIT_GET_AI_COMPANIONS_CHAT_HISTORY, getChatHistorySaga);
  yield takeEvery(initActions.SEND_AI_COMPANIONS_CHAT, sendChatMsgAi);
  yield takeEvery(initActions.UPDATE_AI_COMPANIONS_CHAT_FEEDBACK, updateChatFeedbackSaga);
  yield takeEvery(initActions.INIT_RESULTS_DETAIL, setResultsDetailSaga);
  yield takeEvery(initActions.INIT_INTERESTED_CAREER, saveInterestedCareer);
  yield takeEvery(initActions.INIT_INTERESTED_CAREER, saveInterestedCareer);
  yield takeEvery(initActions.INIT_GET_STRENGTHS, getStrengthsSaga);
  yield takeEvery(initActions.GET_CAREERS_REQUEST, getCareersSaga);
  yield takeEvery(initActions.SET_CAREERS_REQUEST, setCareersSaga);
  yield takeEvery(initActions.INIT_CHECK_AFFILIATE, getAffiliateSaga)
  yield takeEvery(initActions.SET_GENERATE_IDEAS, generateIdeasSaga)
  yield takeEvery(initActions.INIT_GET_TERMS, getTermsSaga)
  yield takeEvery(initActions.SET_TERMS, addTermsSaga)
  yield takeEvery(initActions.DELETE_TERMS, deleteTermSaga)
  yield takeEvery(initActions.DOWNLOAD_ACTION, downloadActionSaga)
  yield takeEvery(initActions.REORDER_ACTION_TERM, reorderTermsSaga)
  yield takeEvery(initActions.INIT_FETCH_PROMPT_STATUS, fetchPromptStatusSaga)
  yield takeEvery(initActions.INIT_LOG_PROMPT, logPromptSaga)
}
